"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var styles_1 = require("@mui/styles");
var SocialMediaHeader_1 = __importDefault(require("./components/SocialMediaHeader"));
var SocialMediaCaption_1 = __importDefault(require("./components/SocialMediaCaption"));
var SocialMediaImage_1 = __importDefault(require("./components/SocialMediaImage"));
var SocialMediaVideo_1 = __importDefault(require("./components/SocialMediaVideo"));
var useStyles = (0, styles_1.makeStyles)({
    background: {
        background: function (_a) {
            var background = _a.background;
            return background;
        },
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: function (_a) {
            var objectFit = _a.objectFit;
            return objectFit;
        },
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute'
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: function (_a) {
            var objectFit = _a.objectFit;
            return objectFit;
        },
        position: 'absolute'
    }
});
var SocialMediaWidget = function (_a) {
    var _b = _a.socialMediaProps, _c = _b.background, background = _c === void 0 ? 'black' : _c, _d = _b.objectFit, objectFit = _d === void 0 ? seesignage_utils_1.FabricWidgetObjectFit.contain : _d, mediaProfile = _b.mediaProfile, showHeader = _b.showHeader, _e = _b.mediaItems, mediaItems = _e === void 0 ? [] : _e, slideShowInterval = _b.slideShowInterval, _f = _b.videosMuted, videosMuted = _f === void 0 ? true : _f, _g = _b.showCaption, showCaption = _g === void 0 ? true : _g, editable = _a.editable;
    var _h = (0, react_1.useState)([]), socialMediaItems = _h[0], setSocialMediaItems = _h[1];
    var _j = (0, react_1.useState)(0), displayIndex = _j[0], setDisplayIndex = _j[1];
    var currentItem = socialMediaItems[displayIndex];
    var getNextIndex = function () { return (displayIndex < socialMediaItems.length - 1 ? displayIndex + 1 : 0); };
    var loadNextItem = function () {
        setDisplayIndex(getNextIndex());
    };
    var deleteItem = function (itemId) {
        setDisplayIndex(function (prevValue) { return prevValue % (socialMediaItems.length - 1); });
        setSocialMediaItems(function (previousItems) { return previousItems.filter(function (item) { return item.id !== itemId; }); });
    };
    var classes = useStyles({
        background: background,
        objectFit: objectFit
    });
    (0, react_1.useEffect)(function () {
        setSocialMediaItems(mediaItems);
        // make sure that playback starts from the first index when mediaItems changes
        setDisplayIndex(0);
    }, [mediaItems]);
    (0, react_1.useEffect)(function () {
        var timer;
        if (currentItem && (0, seesignage_utils_1.isSocialMediaImageItem)(currentItem)) {
            timer = setTimeout(function () {
                setDisplayIndex(getNextIndex());
            }, slideShowInterval * 1000);
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [currentItem, slideShowInterval]);
    // Render media widget only when it has mediaItems
    if (socialMediaItems.length === 0 && !editable) {
        return react_1.default.createElement(react_1.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: classes.background },
        showHeader && react_1.default.createElement(SocialMediaHeader_1.default, { mediaProfile: mediaProfile }),
        socialMediaItems.length > 0 && currentItem && (react_1.default.createElement(react_1.default.Fragment, null,
            (0, seesignage_utils_1.isSocialMediaImageItem)(currentItem) && (react_1.default.createElement(SocialMediaImage_1.default, { src: currentItem.mediaUrl, className: classes.image, deleteItem: function () { return deleteItem(currentItem.id); } })),
            (0, seesignage_utils_1.isSocialMediaVideoItem)(currentItem) && (react_1.default.createElement(SocialMediaVideo_1.default, { src: currentItem.mediaUrl, loopVideo: socialMediaItems.length === 1, loadNextItem: loadNextItem, videosMuted: videosMuted, className: classes.video, deleteItem: function () { return deleteItem(currentItem.id); } })),
            showCaption && currentItem.caption && (react_1.default.createElement(SocialMediaCaption_1.default, { caption: currentItem.caption }))))));
};
exports.default = SocialMediaWidget;
//# sourceMappingURL=SocialMediaWidget.js.map